import { createSlice , createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { checkErrors } from "../../../jsx/global-functions/checkErrors";
export const getNewsLettersFunc = createAsyncThunk(
    "get news letters function",
    async (api) => {
        const token = window.localStorage.getItem("token")
        const config = {
            headers: {
                Authorization: `Bearer ${token}` // Include the token in the Authorization header
            }
        }
        try {
            const response = await axios.get(api , config);
            return response.data.data.newsletters;
        }
        catch (error) {
            checkErrors(error.response , error.message);
        }
        
    }
)

const getNewsLettersSlicer = createSlice({
    name : "get news letters slicer",
    initialState : {
        loading : null,
        data : null,
        error : null
    },
    reducer : {},
    extraReducers : (builder) => {
        builder.addCase(getNewsLettersFunc.pending , (state) => {
            state.loading = true
            state.data = null
            state.error = null
        })
        builder.addCase(getNewsLettersFunc.rejected , (state) => {
            state.loading = null
            state.data = null
            state.error = true
        })
        builder.addCase(getNewsLettersFunc.fulfilled , (state , action) => {
            state.loading = false
            state.data = action.payload
            state.error = null
        })
    }
})

export default getNewsLettersSlicer.reducer;